<template>
  <Reference
    :id="value && value.id"
    :value="value"
    :label="label || 'Тип Сервіса'"
    placeholder="Введіть найменування типу сервіса"
    :items.sync="items"
    :total-items="totalItems"
    component-name="ServiceType"
    @input="$emit('input', $event)"
    @getItems="getItems"
  />
</template>

<script>
import * as serviceTypesApi from "@/backend/serviceTypesApi.js";
import Reference from "@/components/Reference";

export default {
  components: {
    Reference,
  },
  props: {
    label: {
      type: String,
      default: "Тип Сервіса",
    },
    value: {
      type: Object,
    },
  },
  data: () => ({
    items: [],
    totalItems: 0,
  }),
  created() {
    serviceTypesApi.getAllServiceTypes().then((items) => {
      this.items = items;
    });
  },
  methods: {
    async getItems({ currentPage, perPage, search }) {
      const { result, totalItems } = await serviceTypesApi.selectServiceType(
        currentPage,
        perPage,
        search
      );
      this.items = [...this.items, ...result];
      this.totalItems = totalItems;
    },
  },
};
</script>
